"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cadegliano-viconago": {
    "44a45cbc": [{
      "hkey": "d0d2d85e",
      "slug": "cadegliano-arbizzo",
      "name": "Cadegliano-Arbizzo",
      "primary": true,
      "skipSearch": false
    }],
    "arbizzo": [{
      "hkey": "d0d2d85e",
      "slug": "cadegliano-arbizzo",
      "name": "Cadegliano-Arbizzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cadegliano-viconago"
    }],
    "ccecfce2": [{
      "hkey": "d0d2d85e",
      "slug": "cadegliano-arbizzo",
      "name": "Cadegliano-Arbizzo",
      "primary": true,
      "skipSearch": false
    }],
    "cadegliano": [{
      "hkey": "d0d2d85e",
      "slug": "cadegliano-arbizzo",
      "name": "Cadegliano-Arbizzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8076452f": [{
      "hkey": "c13e3ee0",
      "slug": "viconago-ainee-doneda",
      "name": "Viconago-Ainee-Doneda",
      "primary": true,
      "skipSearch": false
    }],
    "doneda": [{
      "hkey": "c13e3ee0",
      "slug": "viconago-ainee-doneda",
      "name": "Viconago-Ainee-Doneda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cadegliano-viconago"
    }],
    "8caf24ab": [{
      "hkey": "c13e3ee0",
      "slug": "viconago-ainee-doneda",
      "name": "Viconago-Ainee-Doneda",
      "primary": true,
      "skipSearch": false
    }],
    "viconago": [{
      "hkey": "c13e3ee0",
      "slug": "viconago-ainee-doneda",
      "name": "Viconago-Ainee-Doneda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;